export const getStorage = () =>
  localStorage.getItem("rememberMe") ? localStorage : sessionStorage;
